import React, { useState } from 'react'
import './css/Navbar.css'
import { Link } from 'react-router-dom'
import { AiOutlineMenu } from 'react-icons/ai'
import { ImCross } from 'react-icons/im'


function Navbar() {
  const [expended, setExpended] = useState(false)
  const navToggle = () => {
    if (expended) {
      setExpended(false)
    }
    else {
      setExpended(true)
    }
  }
  return (
    <div>

      <section id="navigation">
        {expended ? null : <div className="nav-icon" onClick={navToggle} >
          <AiOutlineMenu style={{color:"white", fontSize:"30px"}}/>
        </div>}
      </section>
      {
        expended ? <div id='nav-content'>
          <div className='close-btn' onClick={navToggle} > <ImCross /></div>

          <div className="wrapper">
            <h2 className="section-heading">Menu</h2>
            <nav>
              <ul>
                <li><Link className='link' data-text="Home" to="/" onClick={navToggle}>Home</Link></li>
                <li><Link className='link' data-text="About" to="about" onClick={navToggle}>About</Link></li>
                <li><Link className='link' data-text="Projects" to="projects" onClick={navToggle}>Projects</Link></li>
                <li><Link className='link' data-text="Contact" to="contact" onClick={navToggle}>Contact</Link></li>
              </ul>
            </nav>
          </div>
        </div> : null
      }

    </div>

  )
}

export default Navbar